import { sortType, InputTypes } from '@bento-core/facet-filter';
import clearButton from '../assets/icons/Clear_Icon.svg';
import clearButtonActive from '../assets/icons/Clear_Icon_White.svg';
import clearButtonActiveHover from '../assets/icons/Clear_Icon_Active.svg';
import questionIcon from '../assets/icons/Question_Icon.svg';

const DEMOGRAPHICS = 'Demographics';
const SURVIVAL = 'Survival';
const TREATMENT = 'Treatment';
const TREATMENT_RESPONSE = 'Treatmentresponse';
const DIAGNOSIS = 'Diagnosis';
const GENETIC_ANALYSIS = 'Geneticanalysis';
const SAMPLES = 'Samples';
const DATACATEGORY = 'Datacategory';
const SEQUENCINGLIBRARY = 'Sequencinglibrary';
const STUDY = 'Study';
const GROUP = 'group';

// --------------- Facet resetIcon link configuration --------------
// Ideal size for resetIcon is 16x16 px
export const resetIcon = {
  src: clearButton,
  srcActive: clearButtonActive,
  srcActiveHover: clearButtonActiveHover,
  alt: 'Reset icon',
  size: '12px',
};

export const sectionLabel = {
  Datacategory: "Data Category",
  Sequencinglibrary: 'Sequencing Library',
  Treatmentresponse: 'Treatment Response',
  Geneticanalysis: 'Genetic Analysis',
};

// --------------- Dashboard Sidebar Sections styling --------------
export const facetSectionVariables = {
  Diagnosis: {
    isExpanded: true,
  },
  Geneticanalysis: {
    isExpanded: false,
  },
  Demographics: {
    isExpanded: false,
    hasSearch: true,
  },
  Survival: {
    isExpanded: false,
  },
  Treatment: {
    isExpanded: false,
  },
  Treatmentresponse: {
    isExpanded: false,
  },
  Samples: {
    isExpanded: false,
  },
  Study: {
    isExpanded: false,
  },
};

export const facetSectionVariablesExploreFiles = {
  Datacategory: {
    isExpanded: false,
  },
  Sequencinglibrary: {
    isExpanded: false,
  },
};

export const facetsParticipantsConfig = [
  {
    section: DIAGNOSIS,
    label: 'Diagnosis',
    apiPath: 'participantCountByDiagnosis',
    apiForFiltering: 'filterParticipantCountByDiagnosis',
    datafield: 'diagnosis',
    field: GROUP,
    type: InputTypes.CHECKBOX,
    sort_type: sortType.ALPHABET,
    show: true,
    search: true,
    searchPlaceholder: 'e.g. sarcoma, neoplasm, leukemia',
    expanded: true,
  },
  {
    section: DIAGNOSIS,
    label: 'Diagnosis Category',
    apiPath: 'participantCountByDiagnosisCategory',
    apiForFiltering: 'filterParticipantCountByDiagnosisCategory',
    datafield: 'diagnosis_category',
    field: GROUP,
    type: InputTypes.CHECKBOX,
    sort_type: sortType.ALPHABET,
    show: true,
    search: true,
    searchPlaceholder: 'e.g. sarcoma, neoplasm, leukemia',
  },
  {
    section: DIAGNOSIS,
    label: 'Diagnosis Anatomic Site',
    apiPath: 'participantCountByAnatomicSite',
    apiForFiltering: 'filterParticipantCountByDiagnosisAnatomicSite',
    datafield: 'diagnosis_anatomic_site',
    field: GROUP,
    type: InputTypes.CHECKBOX,
    sort_type: sortType.ALPHABET,
    show: true,
    search: true,
    searchPlaceholder: 'e.g. blood, brain, kidney',
  },
  {
    section: DIAGNOSIS,
    label: 'Age at Diagnosis (Days)',
    apiPath: 'filterParticipantCountByDiagnosisAge',
    apiForFiltering: 'filterParticipantCountByDiagnosisAge',
    datafield: 'age_at_diagnosis',
    ApiLowerBoundName: 'lowerBound',
    ApiUpperBoundName: 'upperBound',
    ApiUnknownAgesName: 'unknownAges',
    defaultUnknownAges: 'include',
    show: true,
    slider: true,
    type: InputTypes.SLIDER,
    sort_type: 'none',
    minLowerBound: 0,
    maxUpperBound: 100,
    quantifier: 'Days',
    style: {
      colorPrimary: {
        color: '#4D889E',
      },
      sliderRoot: {
        marginTop: '1px',
        marginLeft: '20px',
        marginRight: 'Auto',
        paddingRight: '20px',
      },
      minValue: {
        fontFamily: 'Nunito',
        fontSize: '15px',
        color: '#000000',
        marginBottom: '0px',
        float: 'left',
        width: '50%',
        display: 'flex',
      },
      maxValue: {
        fontFamily: 'Nunito',
        fontSize: '15px',
        color: '#000000',
        float: 'right',
        marginBottom: '0px',
        width: '50%',
        display: 'flex',
      },
      rail: {
        borderRadius: 4,
        height: 6,
        background: '#142D64',
      },
      minInputLabel: {
        float: 'left',
        lineHeight: '34px',
        marginRight: '5px',
        fontFamily: 'Montserrat',
        fontSize: '11px',
        fontWeight: 500,
      },
      maxInputLabel: {
        float: 'left',
        lineHeight: '34px',
        marginRight: '5px',
        fontFamily: 'Montserrat',
        fontSize: '11px',
        fontWeight: 500,
      },
      thumb: {
        height: 16,
        width: 16,
        background: '#4D889E',
      },
      invalidThumb: {
        height: 16,
        width: 16,
        background: '#F44336',
      },
      track: {
        borderRadius: 4,
        height: 6,
        background: '#4D889E',
        '&~&': {
          background: '#142D64',
        },
      },
      invalidTrack: {
        borderRadius: 4,
        height: 6,
        background: '#F44336',
        '&~&': {
          background: '#142D64',
        },
      },
      upperBound: {
        fontFamily: 'Nunito',
        fontSize: '10px',
        color: '#000000',
        float: 'right',
        marginLeft: 'Auto',
        marginRight: 'Auto',
        marginBottom: '15px',
      },
      lowerBound: {
        fontFamily: 'Nunito',
        fontSize: '10px',
        color: '#000000',
        float: 'left',
        marginLeft: 'Auto',
        marginRight: 'Auto',
        marginBottom: '15px',
      },
      sliderText: {
        color: '#7D267E',
        lineHeight: '120%',
        fontFamily: 'Nunito',
        fontSize: '14px',
        padding: '5px 15px 5px 0px',
        width: '100%',
        textAlign: 'right',
        background: '#C8A4C840',
        marginTop: '10px',
      },
      invalidSliderText: {
        color: '#D32F2F',
        lineHeight: '120%',
        fontFamily: 'Nunito',
        fontSize: '14px',
        padding: '5px 15px 5px 0px',
        width: '100%',
        textAlign: 'right',
        background: '#E57373',
        marginTop: '10px',
      },
      sliderListItem: {
        height: '15px',
      },
      listItemGutters: {
        display: 'flex',
        justifyContent: 'space-between',
        padding: '2px 5px 2px 8px',
      },
      lowerUpperBound: {
        height: '15px',
      },
    },
  },
  {
    section: DIAGNOSIS,
    label: 'Diagnosis Classification System',
    apiPath: 'participantCountByDiagnosisClassificationSystem',
    apiForFiltering: 'filterParticipantCountByDiagnosisClassificationSystem',
    datafield: 'diagnosis_classification_system',
    field: GROUP,
    type: InputTypes.CHECKBOX,
    sort_type: sortType.ALPHABET,
    show: true,
  },
  {
    section: DIAGNOSIS,
    label: 'Diagnosis Basis',
    apiPath: 'participantCountByDiagnosisBasis',
    apiForFiltering: 'filterParticipantCountByDiagnosisBasis',
    datafield: 'diagnosis_basis',
    field: GROUP,
    type: InputTypes.CHECKBOX,
    sort_type: sortType.ALPHABET,
    show: true,
  },

  /*{
    section: DIAGNOSIS,
    label: 'Tumor Grade Source',
    apiPath: 'participantCountByTumorGradeSource',
    apiForFiltering: 'filterParticipantCountByTumorGradeSource',
    datafield: 'tumor_grade_source',
    field: GROUP,
    type: InputTypes.CHECKBOX,
    sort_type: sortType.ALPHABET,
    show: true,
  },
  {
    section: DIAGNOSIS,
    label: 'Tumor Stage Source',
    apiPath: 'participantCountByTumorStageSource',
    apiForFiltering: 'filterParticipantCountByTumorStageSource',
    datafield: 'tumor_stage_source',
    field: GROUP,
    type: InputTypes.CHECKBOX,
    sort_type: sortType.ALPHABET,
    show: true,
  },*/
  {
    section: DIAGNOSIS,
    label: 'Disease Phase',
    apiPath: 'participantCountByDiseasePhase',
    apiForFiltering: 'filterParticipantCountByDiseasePhase',
    datafield: 'disease_phase',
    field: GROUP,
    type: InputTypes.CHECKBOX,
    sort_type: sortType.ALPHABET,
    show: true,
  },

  {
    section: GENETIC_ANALYSIS,
    label: 'Reported Significance',
    apiPath: '',
    apiForFiltering: 'filterParticipantCountByReportedSignificance',
    datafield: 'reported_significance',
    field: GROUP,
    type: InputTypes.CHECKBOX,
    sort_type: sortType.ALPHABET,
    show: true,
  },
  {
    section: GENETIC_ANALYSIS,
    label: 'Reported Significance System',
    apiPath: '',
    apiForFiltering: 'filterParticipantCountByReportedSignificanceSystem',
    datafield: 'reported_significance_system',
    field: GROUP,
    type: InputTypes.CHECKBOX,
    sort_type: sortType.ALPHABET,
    show: true,
  },
  {
    section: GENETIC_ANALYSIS,
    label: 'Gene Symbol',
    apiPath: '',
    apiForFiltering: 'filterParticipantCountByGeneSymbol', 
    datafield: 'gene_symbol',
    field: GROUP,
    type: InputTypes.CHECKBOX,
    sort_type: sortType.ALPHABET,
    show: true,
    search: true,
    searchPlaceholder: 'e.g. BRAF, TP53, MYCN',
  },
  {
    section: GENETIC_ANALYSIS,
    label: 'Alteration Type',
    apiPath: '',
    apiForFiltering: 'filterParticipantCountByAlterationType',
    datafield: 'alteration_type',
    field: GROUP,
    type: InputTypes.CHECKBOX,
    sort_type: sortType.ALPHABET,
    show: true,
  },
  {
    section: GENETIC_ANALYSIS,
    label: 'Alteration',
    apiPath: '',
    apiForFiltering: 'filterParticipantCountByAlteration',
    datafield: 'alteration',
    field: GROUP,
    type: InputTypes.CHECKBOX,
    sort_type: sortType.ALPHABET,
    show: true,
    search: true,
    searchPlaceholder: 'e.g. Somatic mutation, loss, gain',
  },
  {
    section: GENETIC_ANALYSIS,
    label: 'Fusion Partner Gene',
    apiPath: '',
    apiForFiltering: 'filterParticipantCountByFusionPartnerGene',
    datafield: 'fusion_partner_gene',
    field: GROUP,
    type: InputTypes.CHECKBOX,
    sort_type: sortType.ALPHABET,
    show: true,
  },
  {
    section: GENETIC_ANALYSIS,
    label: 'Status',
    apiPath: '',
    apiForFiltering: 'filterParticipantCountByStatus',
    datafield: 'status',
    field: GROUP,
    type: InputTypes.CHECKBOX,
    sort_type: sortType.ALPHABET,
    show: true,
  },
  {
    section: DEMOGRAPHICS,
    label: 'Sex at Birth',
    apiPath: 'participantCountBySexAtBirth',
    apiForFiltering: 'filterParticipantCountBySexAtBirth',
    datafield: 'sex_at_birth',
    field: GROUP,
    type: InputTypes.CHECKBOX,
    sort_type: sortType.ALPHABET,
    show: true,
  },
  {
    section: DEMOGRAPHICS,
    label: 'Race',
    apiPath: 'participantCountByRace',
    apiForFiltering: 'filterParticipantCountByRace',
    datafield: 'race',
    field: GROUP,
    type: InputTypes.CHECKBOX,
    sort_type: sortType.ALPHABET,
    show: true,
  },
  {
    section: SURVIVAL,
    label: 'Age at Last Known Survival Status (Days)',
    apiPath: 'participantCountByAgeAtLastKnownSurvivalStatus',
    apiForFiltering: 'filterParticipantCountByAgeAtLastKnownSurvivalStatus',
    datafield: 'age_at_last_known_survival_status',
    ApiLowerBoundName: 'lowerBound',
    ApiUpperBoundName: 'upperBound',
    ApiUnknownAgesName: 'unknownAges',
    defaultUnknownAges: 'include',
    show: true,
    slider: true,
    type: InputTypes.SLIDER,
    sort_type: 'none',
    minLowerBound: 0,
    maxUpperBound: 100,
    quantifier: 'Days',
    style: {
      colorPrimary: {
        color: '#CD5C4E',
      },
      sliderRoot: {
        marginTop: '1px',
        marginLeft: '20px',
        marginRight: 'Auto',
        paddingRight: '20px',
      },
      minValue: {
        fontFamily: 'Nunito',
        fontSize: '15px',
        color: '#000000',
        marginBottom: '0px',
        float: 'left',
        width: '75px',
        display: 'flex',
      },
      maxValue: {
        fontFamily: 'Nunito',
        fontSize: '15px',
        color: '#000000',
        float: 'right',
        marginBottom: '0px',
        display: 'flex',
      },
      rail: {
        borderRadius: 4,
        height: 6,
        background: '#142D64',
      },
      minInputLabel: {
        float: 'left',
        lineHeight: '34px',
        marginRight: '5px',
        fontFamily: 'Montserrat',
        fontSize: '11px',
        fontWeight: 500,
      },
      maxInputLabel: {
        float: 'left',
        lineHeight: '34px',
        marginRight: '5px',
        fontFamily: 'Montserrat',
        fontSize: '11px',
        fontWeight: 500,
      },
      thumb: {
        height: 16,
        width: 16,
        background: '#CD5C4E',
      },
      invalidThumb: {
        height: 16,
        width: 16,
        background: '#F44336',
      },
      track: {
        borderRadius: 4,
        height: 6,
        background: '#CD5C4E',
        '&~&': {
          background: '#142D64',
        },
      },
      invalidTrack: {
        borderRadius: 4,
        height: 6,
        background: '#F44336',
        '&~&': {
          background: '#142D64',
        },
      },
      upperBound: {
        fontFamily: 'Nunito',
        fontSize: '10px',
        color: '#000000',
        float: 'right',
        marginLeft: 'Auto',
        marginRight: 'Auto',
        marginBottom: '15px',
      },
      lowerBound: {
        fontFamily: 'Nunito',
        fontSize: '10px',
        color: '#000000',
        float: 'left',
        marginLeft: 'Auto',
        marginRight: 'Auto',
        marginBottom: '15px',
      },
      sliderText: {
        color: '#897E67',
        lineHeight: '120%',
        fontFamily: 'Nunito',
        fontSize: '14px',
        padding: '5px 15px 5px 0px',
        width: '100%',
        textAlign: 'right',
        background: '#D9C5A040',
        marginTop: '10px',
      },
      invalidSliderText: {
        color: '#D32F2F',
        lineHeight: '120%',
        fontFamily: 'Nunito',
        fontSize: '14px',
        padding: '5px 15px 5px 0px',
        width: '100%',
        textAlign: 'right',
        background: '#E57373',
        marginTop: '10px',
      },
      sliderListItem: {
        height: '15px',
      },
      listItemGutters: {
        display: 'flex',
        justifyContent: 'space-between',
        padding: '2px 5px 2px 8px',
      },
      lowerUpperBound: {
        height: '15px',
      },
    }
  },
  {
    section: SURVIVAL,
    label: 'First Event',
    apiPath: 'participantFirstEvent',
    apiForFiltering: 'filterParticipantCountByFirstEvent',
    datafield: 'first_event',
    field: GROUP,
    type: InputTypes.CHECKBOX,
    sort_type: sortType.ALPHABET,
    show: true,
  },
  {
    section: SURVIVAL,
    label: 'Last Known Survival Status',
    apiPath: 'participantCountBySurvivalStatus',
    apiForFiltering: 'filterParticipantCountBySurvivalStatus',
    datafield: 'last_known_survival_status',
    field: GROUP,
    type: InputTypes.CHECKBOX,
    sort_type: sortType.ALPHABET,
    show: true,
  },
  {
    section: SURVIVAL,
    label: 'Cause of Death',
    apiPath: 'participantCountByCauseOfDeath',
    apiForFiltering: 'filterParticipantCountByCauseOfDeath',
    datafield: 'cause_of_death',
    field: GROUP,
    type: InputTypes.CHECKBOX,
    sort_type: sortType.ALPHABET,
    show: true,
  },
  {
    section: TREATMENT,
    label: 'Age at Treatment Start',
    apiPath: 'participantCountByAgeAtTreatmentStart',
    apiForFiltering: 'filterParticipantCountByAgeAtTreatmentStart',
    datafield: 'age_at_treatment_start',
    ApiLowerBoundName: 'lowerBound',
    ApiUpperBoundName: 'upperBound',
    ApiUnknownAgesName: 'unknownAges',
    defaultUnknownAges: 'include',
    show: true,
    slider: true,
    type: InputTypes.SLIDER,
    sort_type: 'none',
    minLowerBound: 0,
    maxUpperBound: 100,
    quantifier: 'Days',
    style: {
      colorPrimary: {
        color: '#4150A4',
      },
      sliderRoot: {
        marginTop: '1px',
        marginLeft: '20px',
        marginRight: 'Auto',
        paddingRight: '20px',
      },
      minValue: {
        fontFamily: 'Nunito',
        fontSize: '15px',
        color: '#000000',
        marginBottom: '0px',
        float: 'left',
        width: '75px',
        display: 'flex',
      },
      maxValue: {
        fontFamily: 'Nunito',
        fontSize: '15px',
        color: '#000000',
        float: 'right',
        marginBottom: '0px',
        display: 'flex',
      },
      rail: {
        borderRadius: 4,
        height: 6,
        background: '#142D64',
      },
      minInputLabel: {
        float: 'left',
        lineHeight: '34px',
        marginRight: '5px',
        fontFamily: 'Montserrat',
        fontSize: '11px',
        fontWeight: 500,
      },
      maxInputLabel: {
        float: 'left',
        lineHeight: '34px',
        marginRight: '5px',
        fontFamily: 'Montserrat',
        fontSize: '11px',
        fontWeight: 500,
      },
      thumb: {
        height: 16,
        width: 16,
        background: '#4150A4',
      },
      invalidThumb: {
        height: 16,
        width: 16,
        background: '#F44336',
      },
      track: {
        borderRadius: 4,
        height: 6,
        background: '#4150A4',
        '&~&': {
          background: '#142D64',
        },
      },
      invalidTrack: {
        borderRadius: 4,
        height: 6,
        background: '#F44336',
        '&~&': {
          background: '#142D64',
        },
      },
      upperBound: {
        fontFamily: 'Nunito',
        fontSize: '10px',
        color: '#000000',
        float: 'right',
        marginLeft: 'Auto',
        marginRight: 'Auto',
        marginBottom: '15px',
      },
      lowerBound: {
        fontFamily: 'Nunito',
        fontSize: '10px',
        color: '#000000',
        float: 'left',
        marginLeft: 'Auto',
        marginRight: 'Auto',
        marginBottom: '15px',
      },
      sliderText: {
        color: '#897E67',
        lineHeight: '120%',
        fontFamily: 'Nunito',
        fontSize: '14px',
        padding: '5px 15px 5px 0px',
        width: '100%',
        textAlign: 'right',
        background: '#D9C5A040',
        marginTop: '10px',
      },
      invalidSliderText: {
        color: '#D32F2F',
        lineHeight: '120%',
        fontFamily: 'Nunito',
        fontSize: '14px',
        padding: '5px 15px 5px 0px',
        width: '100%',
        textAlign: 'right',
        background: '#E57373',
        marginTop: '10px',
      },
      sliderListItem: {
        height: '15px',
      },
      listItemGutters: {
        display: 'flex',
        justifyContent: 'space-between',
        padding: '2px 5px 2px 8px',
      },
      lowerUpperBound: {
        height: '15px',
      },
    }
  },
  {
    section: TREATMENT,
    label: 'Age at Treatment End',
    apiPath: 'participantCountByAgeAtTreatmentEnd',
    apiForFiltering: 'filterParticipantCountByAgeAtTreatmentEnd',
    datafield: 'age_at_treatment_end',
    ApiLowerBoundName: 'lowerBound',
    ApiUpperBoundName: 'upperBound',
    ApiUnknownAgesName: 'unknownAges',
    defaultUnknownAges: 'include',
    show: true,
    slider: true,
    type: InputTypes.SLIDER,
    sort_type: 'none',
    minLowerBound: 0,
    maxUpperBound: 100,
    quantifier: 'Days',
    style: {
      colorPrimary: {
        color: '#4150A4',
      },
      sliderRoot: {
        marginTop: '1px',
        marginLeft: '20px',
        marginRight: 'Auto',
        paddingRight: '20px',
      },
      minValue: {
        fontFamily: 'Nunito',
        fontSize: '15px',
        color: '#000000',
        marginBottom: '0px',
        float: 'left',
        width: '75px',
        display: 'flex',
      },
      maxValue: {
        fontFamily: 'Nunito',
        fontSize: '15px',
        color: '#000000',
        float: 'right',
        marginBottom: '0px',
        display: 'flex',
      },
      rail: {
        borderRadius: 4,
        height: 6,
        background: '#142D64',
      },
      minInputLabel: {
        float: 'left',
        lineHeight: '34px',
        marginRight: '5px',
        fontFamily: 'Montserrat',
        fontSize: '11px',
        fontWeight: 500,
      },
      maxInputLabel: {
        float: 'left',
        lineHeight: '34px',
        marginRight: '5px',
        fontFamily: 'Montserrat',
        fontSize: '11px',
        fontWeight: 500,
      },
      thumb: {
        height: 16,
        width: 16,
        background: '#4150A4',
      },
      invalidThumb: {
        height: 16,
        width: 16,
        background: '#F44336',
      },
      track: {
        borderRadius: 4,
        height: 6,
        background: '#4150A4',
        '&~&': {
          background: '#142D64',
        },
      },
      invalidTrack: {
        borderRadius: 4,
        height: 6,
        background: '#F44336',
        '&~&': {
          background: '#142D64',
        },
      },
      upperBound: {
        fontFamily: 'Nunito',
        fontSize: '10px',
        color: '#000000',
        float: 'right',
        marginLeft: 'Auto',
        marginRight: 'Auto',
        marginBottom: '15px',
      },
      lowerBound: {
        fontFamily: 'Nunito',
        fontSize: '10px',
        color: '#000000',
        float: 'left',
        marginLeft: 'Auto',
        marginRight: 'Auto',
        marginBottom: '15px',
      },
      sliderText: {
        color: '#897E67',
        lineHeight: '120%',
        fontFamily: 'Nunito',
        fontSize: '14px',
        padding: '5px 15px 5px 0px',
        width: '100%',
        textAlign: 'right',
        background: '#D9C5A040',
        marginTop: '10px',
      },
      invalidSliderText: {
        color: '#D32F2F',
        lineHeight: '120%',
        fontFamily: 'Nunito',
        fontSize: '14px',
        padding: '5px 15px 5px 0px',
        width: '100%',
        textAlign: 'right',
        background: '#E57373',
        marginTop: '10px',
      },
      sliderListItem: {
        height: '15px',
      },
      listItemGutters: {
        display: 'flex',
        justifyContent: 'space-between',
        padding: '2px 5px 2px 8px',
      },
      lowerUpperBound: {
        height: '15px',
      },
    }
  },
  {
    section: TREATMENT,
    label: 'Treatment Type',
    apiPath: 'participantCountByTreatmentType',
    apiForFiltering: 'filterParticipantCountByTreatmentType',
    datafield: 'treatment_type',
    field: GROUP,
    type: InputTypes.CHECKBOX,
    sort_type: sortType.ALPHABET,
    show: true,
  },
  {
    section: TREATMENT,
    label: 'Treatment Agent',
    apiPath: 'participantCountByTreatmentAgent',
    apiForFiltering: 'filterParticipantCountByTreatmentAgent',
    datafield: 'treatment_agent',
    field: GROUP,
    type: InputTypes.CHECKBOX,
    sort_type: sortType.ALPHABET,
    show: true,
  },
  {
    section: TREATMENT_RESPONSE,
    label: 'Age at Response',
    apiPath: 'participantCountByAgeAtResponse',
    apiForFiltering: 'filterParticipantCountByAgeAtResponse',
    datafield: 'age_at_response',
    ApiLowerBoundName: 'lowerBound',
    ApiUpperBoundName: 'upperBound',
    ApiUnknownAgesName: 'unknownAges',
    defaultUnknownAges: 'include',
    show: true,
    slider: true,
    type: InputTypes.SLIDER,
    sort_type: 'none',
    minLowerBound: 0,
    maxUpperBound: 100,
    quantifier: 'Days',
    style: {
      colorPrimary: {
        color: '#E9B34A',
      },
      sliderRoot: {
        marginTop: '1px',
        marginLeft: '20px',
        marginRight: 'Auto',
        paddingRight: '20px',
      },
      minValue: {
        fontFamily: 'Nunito',
        fontSize: '15px',
        color: '#000000',
        marginBottom: '0px',
        float: 'left',
        width: '75px',
        display: 'flex',
      },
      maxValue: {
        fontFamily: 'Nunito',
        fontSize: '15px',
        color: '#000000',
        float: 'right',
        marginBottom: '0px',
        display: 'flex',
      },
      rail: {
        borderRadius: 4,
        height: 6,
        background: '#142D64',
      },
      minInputLabel: {
        float: 'left',
        lineHeight: '34px',
        marginRight: '5px',
        fontFamily: 'Montserrat',
        fontSize: '11px',
        fontWeight: 500,
      },
      maxInputLabel: {
        float: 'left',
        lineHeight: '34px',
        marginRight: '5px',
        fontFamily: 'Montserrat',
        fontSize: '11px',
        fontWeight: 500,
      },
      thumb: {
        height: 16,
        width: 16,
        background: '#E9B34A',
      },
      invalidThumb: {
        height: 16,
        width: 16,
        background: '#F44336',
      },
      track: {
        borderRadius: 4,
        height: 6,
        background: '#E9B34A',
        '&~&': {
          background: '#142D64',
        },
      },
      invalidTrack: {
        borderRadius: 4,
        height: 6,
        background: '#F44336',
        '&~&': {
          background: '#142D64',
        },
      },
      upperBound: {
        fontFamily: 'Nunito',
        fontSize: '10px',
        color: '#000000',
        float: 'right',
        marginLeft: 'Auto',
        marginRight: 'Auto',
        marginBottom: '15px',
      },
      lowerBound: {
        fontFamily: 'Nunito',
        fontSize: '10px',
        color: '#000000',
        float: 'left',
        marginLeft: 'Auto',
        marginRight: 'Auto',
        marginBottom: '15px',
      },
      sliderText: {
        color: '#897E67',
        lineHeight: '120%',
        fontFamily: 'Nunito',
        fontSize: '14px',
        padding: '5px 15px 5px 0px',
        width: '100%',
        textAlign: 'right',
        background: '#D9C5A040',
        marginTop: '10px',
      },
      invalidSliderText: {
        color: '#D32F2F',
        lineHeight: '120%',
        fontFamily: 'Nunito',
        fontSize: '14px',
        padding: '5px 15px 5px 0px',
        width: '100%',
        textAlign: 'right',
        background: '#E57373',
        marginTop: '10px',
      },
      sliderListItem: {
        height: '15px',
      },
      listItemGutters: {
        display: 'flex',
        justifyContent: 'space-between',
        padding: '2px 5px 2px 8px',
      },
      lowerUpperBound: {
        height: '15px',
      },
    }
  },
  {
    section: TREATMENT_RESPONSE,
    label: 'Response',
    apiPath: 'participantCountByResponse',
    apiForFiltering: 'filterParticipantCountByResponse',
    datafield: 'response',
    field: GROUP,
    type: InputTypes.CHECKBOX,
    sort_type: sortType.ALPHABET,
    show: true,
  },
  {
    section: TREATMENT_RESPONSE,
    label: 'Response Category',
    apiPath: 'participantCountByResponseCategory',
    apiForFiltering: 'filterParticipantCountByResponseCategory',
    datafield: 'response_category',
    field: GROUP,
    type: InputTypes.CHECKBOX,
    sort_type: sortType.ALPHABET,
    show: true,
  },
  {
    section: TREATMENT_RESPONSE,
    label: 'Response System',
    apiPath: 'participantCountByResponseSystem',
    apiForFiltering: 'filterParticipantCountByResponseSystem',
    datafield: 'response_system',
    field: GROUP,
    type: InputTypes.CHECKBOX,
    sort_type: sortType.ALPHABET,
    show: true,
  },

  {
    section: SAMPLES,
    label: 'Age at Collection',
    apiPath: 'filterParticipantCountBySampleAge',
    apiForFiltering: 'filterParticipantCountBySampleAge',
    datafield: 'participant_age_at_collection',
    ApiLowerBoundName: 'lowerBound',
    ApiUpperBoundName: 'upperBound',
    ApiUnknownAgesName: 'unknownAges',
    defaultUnknownAges: 'include',
    show: true,
    slider: true,
    type: InputTypes.SLIDER,
    sort_type: 'none',
    minLowerBound: 0,
    maxUpperBound: 100,
    quantifier: 'Days',
    style: {
      colorPrimary: {
        color: '#1F6BBF',
      },
      sliderRoot: {
        marginTop: '1px',
        marginLeft: '20px',
        marginRight: 'Auto',
        paddingRight: '20px',
      },
      minValue: {
        fontFamily: 'Nunito',
        fontSize: '15px',
        color: '#000000',
        marginBottom: '0px',
        float: 'left',
        width: '75px',
        display: 'flex',
      },
      maxValue: {
        fontFamily: 'Nunito',
        fontSize: '15px',
        color: '#000000',
        float: 'right',
        marginBottom: '0px',
        display: 'flex',
      },
      rail: {
        borderRadius: 4,
        height: 6,
        background: '#4150A4',
      },
      minInputLabel: {
        float: 'left',
        lineHeight: '34px',
        marginRight: '5px',
        fontFamily: 'Montserrat',
        fontSize: '11px',
        fontWeight: 500,
      },
      maxInputLabel: {
        float: 'left',
        lineHeight: '34px',
        marginRight: '5px',
        fontFamily: 'Montserrat',
        fontSize: '11px',
        fontWeight: 500,
      },
      thumb: {
        height: 16,
        width: 16,
        background: '#1F6BBF',
      },
      invalidThumb: {
        height: 16,
        width: 16,
        background: '#F44336',
      },
      track: {
        borderRadius: 4,
        height: 6,
        background: '#1F6BBF',
        '&~&': {
          background: '#142D64',
        },
      },
      invalidTrack: {
        borderRadius: 4,
        height: 6,
        background: '#F44336',
        '&~&': {
          background: '#142D64',
        },
      },
      upperBound: {
        fontFamily: 'Nunito',
        fontSize: '10px',
        color: '#000000',
        float: 'right',
        marginLeft: 'Auto',
        marginRight: 'Auto',
        marginBottom: '15px',
      },
      lowerBound: {
        fontFamily: 'Nunito',
        fontSize: '10px',
        color: '#000000',
        float: 'left',
        marginLeft: 'Auto',
        marginRight: 'Auto',
        marginBottom: '15px',
      },
      sliderText: {
        color: '#897E67',
        lineHeight: '120%',
        fontFamily: 'Nunito',
        fontSize: '14px',
        padding: '5px 15px 5px 0px',
        width: '100%',
        textAlign: 'right',
        background: '#D9C5A040',
        marginTop: '10px',
      },
      invalidSliderText: {
        color: '#D32F2F',
        lineHeight: '120%',
        fontFamily: 'Nunito',
        fontSize: '14px',
        padding: '5px 15px 5px 0px',
        width: '100%',
        textAlign: 'right',
        background: '#E57373',
        marginTop: '10px',
      },
      sliderListItem: {
        height: '15px',
      },
      listItemGutters: {
        display: 'flex',
        justifyContent: 'space-between',
        padding: '2px 5px 2px 8px',
      },
      lowerUpperBound: {
        height: '15px',
      },
    }
  },
  {
    section: SAMPLES,
    label: 'Sample Anatomic Site',
    apiPath: 'participantCountBySampleAnatomicSite',
    apiForFiltering: 'filterParticipantCountBySampleAnatomicSite',
    datafield: 'sample_anatomic_site',
    field: GROUP,
    type: InputTypes.CHECKBOX,
    sort_type: sortType.ALPHABET,
    show: true,
    search: true,
    searchPlaceholder: 'e.g. blood, brain, kidney',
  },
    {
    section: SAMPLES,
    label: 'Tumor Spatial Extent',
    apiPath: 'participantCountByTumorSpatialExtent',
    apiForFiltering: 'filterParticipantCountByTumorSpatialExtent',
    datafield: 'tumor_spatial_extent',
    field: GROUP,
    type: InputTypes.CHECKBOX,
    sort_type: sortType.ALPHABET,
    show: true,
  },
  {
    section: SAMPLES,
    label: 'Sample Tumor Status',
    apiPath: 'participantCountByTumorStatus',
    apiForFiltering: 'filterParticipantCountByTumorStatus',
    datafield: 'sample_tumor_status',
    field: GROUP,
    type: InputTypes.CHECKBOX,
    sort_type: sortType.ALPHABET,
    show: true,
  },
  {
    section: STUDY,
    label: 'dbGaP Accession',
    apiPath: 'participantCountByDBGAPAccession',
    apiForFiltering: 'filterParticipantCountByDBGAPAccession',
    datafield: 'dbgap_accession',
    field: GROUP,
    type: InputTypes.CHECKBOX,
    sort_type: sortType.ALPHABET,
    show: true,
  },
  {
    section: STUDY,
    label: 'Study Name',
    apiPath: 'participantCountByStudyTitle',
    apiForFiltering: 'filterParticipantCountByStudyTitle',
    datafield: 'study_name',
    field: GROUP,
    type: InputTypes.CHECKBOX,
    sort_type: sortType.ALPHABET,
    show: true,
  },
  {
    section: STUDY,
    label: 'Study Phase',
    apiPath: 'participantCountByStudyPhase',
    apiForFiltering: 'filterParticipantCountByStudyPhase',
    datafield: 'study_phase',
    field: GROUP,
    type: InputTypes.CHECKBOX,
    sort_type: sortType.ALPHABET,
    show: true,
  },
];


export const facetsExploreFilesConfig = [
  {
    section: DATACATEGORY,
    label: 'Data Category',
    apiPath: 'ParticipantCountByDataCategory',
    apiForFiltering: 'filterFileCountByDataCategory',
    datafield: 'data_category',
    field: GROUP,
    type: InputTypes.CHECKBOX,
    sort_type: sortType.ALPHABET,
    show: true,
  },
  {
    section: DATACATEGORY,
    label: 'File Type',
    apiPath: 'participantCountByFileType',
    apiForFiltering: 'filterFileCountByFileType',
    datafield: 'file_type',
    field: GROUP,
    type: InputTypes.CHECKBOX,
    sort_type: sortType.ALPHABET,
    show: true,
  },
  {
    section: DATACATEGORY,
    label: 'File Mapping',
    apiPath: 'participantCountByFileMappingLevel',
    apiForFiltering: 'filterFileCountByFileMappingLevel',
    datafield: 'file_mapping_level',
    field: GROUP,
    type: InputTypes.CHECKBOX,
    sort_type: sortType.ALPHABET,
    show: true,
  },
  {
    section: SEQUENCINGLIBRARY,
    label: 'Library Selection',
    apiPath: 'participantCountByLibrarySelection',
    apiForFiltering: 'filterFileCountByLibrarySelection',
    datafield: 'library_selection',
    field: GROUP,
    type: InputTypes.CHECKBOX,
    sort_type: sortType.ALPHABET,
    show: true,
  },
  {
    section: SEQUENCINGLIBRARY,
    label: 'Library Source Material',
    apiPath: 'participantCountByLibrarySourceMaterial',
    apiForFiltering: 'filterFileCountByLibrarySourceMaterial',
    datafield: 'library_source_material',
    field: GROUP,
    type: InputTypes.CHECKBOX,
    sort_type: sortType.ALPHABET,
    show: true,
  },
  {
    section: SEQUENCINGLIBRARY,
    label: 'Library Strategy',
    apiPath: 'participantCountByLibraryStrategy',
    apiForFiltering: 'filterFileCountByLibraryStrategy',
    datafield: 'library_strategy',
    field: GROUP,
    type: InputTypes.CHECKBOX,
    sort_type: sortType.ALPHABET,
    show: true,
  },
  {
    section: SEQUENCINGLIBRARY,
    label: 'Library Source Molecule',
    apiPath: 'participantCountByLibrarySourceMolecule',
    apiForFiltering: 'filterFileCountByLibrarySourceMolecule',
    datafield: 'library_source_molecule',
    field: GROUP,
    type: InputTypes.CHECKBOX,
    sort_type: sortType.ALPHABET,
    show: true,
  },
];

// --------------- Dashboard Widgets configuration --------------
// Sunburst chart color scheme
export const SUNBURST_COLORS_LEVEL_1 = [
  '#7dc242',
  '#274fa5',
  '#79287c',
  '#f78f48',
  '#057ebd',
];

export const SUNBURST_COLORS_LEVEL_2 = [
  '#057ebd',
  '#f78f48',
  '#79287c',
  '#0e3151',
  '#057ebd',
  '#7dc242',
];

// A maximum of 6 widgets are allowed
// for donuts only the following are required: type, title, dataName
//
// type: 'sunburst' | 'donut'
// title: string
// dataName: string
// datatable_level1_field: string
// datatable_level1_colors: string[]
// datatable_level2_field: string
// datatable_level2_colors: string[]
// sliceTitle: string (optional)
export const participantWidgetConfig = [
  // {
  //   type: 'sunburst',
  //   title: 'Programs and Arms',
  //   dataName: 'armsByPrograms',
  //   datatable_level1_field: 'program',
  //   datatable_level1_colors: SUNBURST_COLORS_LEVEL_1,
  //   datatable_level2_field: 'arm',
  //   datatable_level2_colors: SUNBURST_COLORS_LEVEL_2,
  // },
  {
    type: 'donut',
    title: 'Study',
    dataName: 'participantCountByStudy',
    sliceTitle: 'Participants',
    width: '100%',
    height: 210,
    tooltip: 'Switch displays between pie and bar charts',
    countType: 'discrete',
  },
  {
    type: 'donut',
    title: 'Diagnosis Category',
    dataName: 'participantCountByDiagnosisCategory',
    sliceTitle: 'Participants',
    width: '100%',
    height: 210,
    tooltip: 'Switch displays between pie and bar charts',
    countType: 'discrete',
  },
  {
    type: 'bar',
    title: 'Age at Diagnosis (years)',
    dataName: 'participantCountByDiagnosisAge',
    width: '100%',
    height: 210,
    tooltip: 'Switch displays between pie and bar charts',
    countType: 'continuous',
  },
  {
    type: 'donut',
    title: 'Sex at Birth',
    dataName: 'participantCountBySexAtBirth',
    sliceTitle: 'Participants',
    width: '100%',
    height: 210,
    tooltip: 'Switch displays between pie and bar charts',
    countType: 'discrete',
  },
  {
    type: 'donut',
    title: 'Race',
    dataName: 'participantCountByRace',
    sliceTitle: 'Participants',
    width: '100%',
    height: 210,
    tooltip: 'Switch displays between pie and bar charts',
    countType: 'discrete',
  },
  {
    type: 'donut',
    title: 'Anatomic Site',
    dataName: 'participantCountByDiagnosisAnatomicSite',
    sliceTitle: 'Participants',
    width: '100%',
    height: 210,
    tooltip: 'Switch displays between pie and bar charts',
    countType: 'discrete',
  },
];

export const WIDGET_DATASET_LIMIT = 20;

export const participantWidgetToolTipConfig = {
  Study: {
    icon: questionIcon,
    alt: 'study tooltip question mark icon',
    arrow: true,
    maxWidth: '230px',
    clsName: 'widgetTotalTooltipIcon',
    plural: 'studies',
  },
  'Diagnosis Category': {
    icon: questionIcon,
    alt: 'diagnosis category tooltip question mark icon',
    arrow: true,
    maxWidth: '230px',
    clsName: 'widgetTotalTooltipIcon',
    plural: 'diagnosis categories',
  },
  'Age at Diagnosis (years)': {
    icon: questionIcon,
    alt: 'age at diagnosis tooltip question mark icon',
    arrow: true,
    maxWidth: '230px',
    clsName: 'widgetTotalTooltipIcon',
    plural: 'age groups',
  },
  'Sex at Birth': {
    icon: questionIcon,
    alt: 'sex tooltip question mark icon',
    arrow: true,
    maxWidth: '230px',
    clsName: 'widgetTotalTooltipIcon',
    plural: 'sexes',
  },
  Race: {
    icon: questionIcon,
    alt: 'race tooltip question mark icon',
    arrow: true,
    maxWidth: '230px',
    clsName: 'widgetTotalTooltipIcon',
    plural: 'races',
  },
  'Anatomic Site': {
    icon: questionIcon,
    alt: 'anatomic site tooltip question mark icon',
    arrow: true,
    maxWidth: '230px',
    clsName: 'widgetTotalTooltipIcon',
    plural: 'anatomic sites',
  },
};

export const filesWidgetConfig = [
  {
    type: 'donut',
    title: 'Data Category',
    dataName: 'fileCountByDataCategory',
    sliceTitle: 'Files',
    width: '100%',
    height: 210,
    tooltip: 'Switch displays between pie and bar charts',
    countType: 'discrete',
  },
  {
    type: 'donut',
    title: 'File Type',
    dataName: 'fileCountByFileType',
    sliceTitle: 'Files',
    width: '100%',
    height: 210,
    tooltip: 'Switch displays between pie and bar charts',
    countType: 'discrete',
  },
  {
    type: 'donut',
    title: 'Library Strategy',
    dataName: 'fileCountByLibraryStrategy',
    sliceTitle: 'Files',
    width: '100%',
    height: 210,
    tooltip: 'Switch displays between pie and bar charts',
    countType: 'discrete',
  },
];

export const filesWidgetToolTipConfig = {
  'Data Category': {
    icon: questionIcon,
    alt: 'data category tooltip question mark icon',
    arrow: true,
    maxWidth: '230px',
    clsName: 'widgetTotalTooltipIcon',
    plural: 'data categories',
  },
  'File Type': {
    icon: questionIcon,
    alt: 'file type tooltip question mark icon',
    arrow: true,
    maxWidth: '230px',
    clsName: 'widgetTotalTooltipIcon',
    plural: 'file types',
  },
  'Library Strategy': {
    icon: questionIcon,
    alt: 'library strategy tooltip question mark icon',
    arrow: true,
    maxWidth: '230px',
    clsName: 'widgetTotalTooltipIcon',
    plural: 'library strategies',
  },
};

// --------------- query url configuration --------------
// Facets, tab, pagination paramters
export const queryParams = [
  'import_from', 'p_id', 'p_syn', 'u', 'u_fc', 'u_um', 'sex_at_birth', 'race',
  'age_at_diagnosis', 'age_at_diagnosis_unknownAges', 'diagnosis', 'diagnosis_anatomic_site', 'diagnosis_classification_system', 'diagnosis_basis', 'diagnosis_category', 'disease_phase',
  'reported_significance', 'reported_significance_system', 'gene_symbol', 'alteration', 'fusion_partner_gene', 'alteration_type', 'status',
  'treatment_type', 'treatment_agent', 'age_at_treatment_start', 'age_at_treatment_start_unknownAges', 'age_at_treatment_end', 'age_at_treatment_end_unknownAges',
  'response', 'age_at_response', 'response_category', 'response_system', 'age_at_response_unknownAges',
  'age_at_last_known_survival_status', 'age_at_last_known_survival_status_unknownAges', 'cause_of_death', 'first_event', 'last_known_survival_status', 
  'participant_age_at_collection', 'participant_age_at_collection_unknownAges', 'sample_anatomic_site', 'sample_tumor_status', 'tumor_spatial_extent', 
  'data_category', 'file_type', 'file_mapping_level', 'dbgap_accession', 'study_name', 'study_phase',
  'library_selection', 'library_strategy', 'library_source_material', 'library_source_molecule',
  'tab_participants', 'tab_files',
];
